var Mn = require('backbone.marionette');
require('slick-carousel');

module.exports = Mn.Behavior.extend({
    onAttach: function (view) {
        this.build(view.$el);
    },
    onChildviewAttach: function (view) {
        var content = view.$el;
        if (content.find('[data-carousel]').length) {
            this.build(content);
        }
    },
    build: function (content, reinit) {

        $('[data-carousel]', content).each(function(){
            if (!reinit && $(this).data('carousel-init'))
                return;

            $(this).data('carousel-init', true);
            var self = this;
            var auto = ($(this).attr('data-carousel-auto') == 'false' ? false : true);
            var height = ($(this).attr('data-carousel-height') == 'true' ? true : false);
            var speed = $(this).attr('data-carousel-speed') || 500;

            var prevArrow = $(this).data('prev-arrow');
            var nextArrow = $(this).data('next-arrow');

            $(this).slick({
                speed: speed,
                arrows: $(this).attr('data-carousel-arrows') === 'true' ? true : false,
                nextArrow: nextArrow,
                prevArrow: prevArrow,
                dots: $(this).attr('data-carousel-dots') === 'false' ? false : true,
                autoplay: auto,
                slidesToShow: 1,
                slidesToScroll: 1,
                centerMode:true,
                centerPadding: $('.highlight__showcase__item').outerWidth() / 2,
                infinite: true,
                mobileFirst: true,
                adaptiveHeight: height,
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            arrows: true,
                            dots: $(this).attr('data-carousel-dots') === 'false' ? false : true,
                            slidesToShow: 1,
                            variableWidth: $(this).attr('data-carousel-variable') === 'false' ? false : true,
                            adaptiveHeight: height,
                        }
                    }
                ]
            }).on('beforeChange', function(event, slick, currentSlide){
                var iframe = $(slick.$slides[currentSlide]).find('iframe');
                var clone = iframe.clone();
                setTimeout(function() {
                    iframe.parent().html(clone);
                }, 300);
            });
        });
        $('.highlight__showcase__caption-wrapper').show();
    }
});



//////////////////
// WEBPACK FOOTER
// ./resources/assets/site/scripts/behaviors/Carousel.js
// module id = 59
// module chunks = 3